import { gql } from '@apollo/client';

export const VERIFY_EMAIL = gql`
  query verifyEmail($input: VerifyEmailInput!) {
    verifyEmail(input: $input) {
      scopes
      email
    }
  }
`;
